// extracted by mini-css-extract-plugin
module.exports = {"testimonial":"testimonial_testimonial__2R79n","customDot":"testimonial_customDot__1VOio","active":"testimonial_active__23keZ"};